// Librerias
import React from 'react'
// Estilos
import * as css from './InputFecha.css'

class InputFecha extends React.Component{
    constructor(props) {
        super(props)
        this.state = {
            dia: '-',
            mes: '-',
            anno: '-',
            diaDirty: false, mesDirty: false, annoDirty: false,
            diaValid: true,  mesValid: true,  annoValid: true
        }
    }
    componentWillMount(){
        let [anno1, mes1, dia1] = this.props.fecha.split('-')
        this.setState({
            dia: dia1,
            mes: mes1,
            anno: anno1,
            diaDirty: false, mesDirty: false, annoDirty: false,
            diaValid: true,  mesValid: true,  annoValid: true
        })
    }
    componentWillReceiveProps(nextProps){
        // apenas se reciba una nueva propiedad, reemplazar el estado independiente de su contenido
        let [anno2, mes2, dia2] = nextProps.fecha.split('-')
            this.setState({
                dia: dia2,
                mes: mes2,
                anno: anno2,
                diaDirty: false, mesDirty: false, annoDirty: false,
                diaValid: true,  mesValid: true,  annoValid: true
            })
    }

    getEstado(){
        return {
            dirty: this.state.diaDirty || this.state.mesDirty || this.state.annoDirty,
            valid: this.state.diaValid && this.state.mesValid && this.state.annoValid,
            fecha: `${this.state.anno}-${this.state.mes}-${this.state.dia}`
        }
    }
    focus(){
        this.inputDia.focus()
        this.inputDia.select()
    }

    inputOnKeyDown(evt){
        if((evt.keyCode===9 && evt.shiftKey===false) || evt.keyCode===40 || evt.keyCode===13){
            // 9 = tab, flechaAbajo = 40,  13 = enter
            evt.preventDefault()
            //this.props.onGuardar()    // no es necesario porque se guarda cuando pierde el focus (focusRowSiguiente),
            this.props.focusRowSiguiente()

        }else if((evt.keyCode===9 && evt.shiftKey===true) || evt.keyCode===38) {
            // flechaArriba = 38, shift+tab
            evt.preventDefault()
            //this.props.onGuardar()    // no es necesario porque se guarda cuando pierde el focus (focusRowAnterior),
            this.props.focusRowAnterior()
        }
    }


    _diaValido(dia){
        return dia>=0 && dia<32
    }
    _mesValido(mes){
        return mes>=1 && mes<=12
    }
    _yearValido(year){
        return year>= 1 && year <= 2026    }

    onDiaChange(evt){
        let dia = evt.target.value
        let diaOriginal = this.props.fecha.split('-')[2]
        this.setState({
            dia: dia,
            diaDirty: dia!=diaOriginal,
            diaValid: this._diaValido(dia)
        })
    }
    onMesChange(evt){
        let mes = evt.target.value
        let mesOriginal = this.props.fecha.split('-')[1]
        this.setState({
            mes: mes,
            mesDirty: mes!=mesOriginal,
            mesValid: this._mesValido(mes)
        })
    }
    onYearChange(evt){
        let anno = evt.target.value
        let annoOriginal = this.props.fecha.split('-')[1]
        this.setState({
            anno: anno,
            annoDirty: anno!=annoOriginal,
            annoValid: this._yearValido(anno)
        })
    }

    render(){
        let classnameDia = this.state.diaValid
            ? (this.state.diaDirty? css.inputDiaDirty : css.inputDia)
            : css.inputDiaInvalido
        let classnameMes = this.state.mesValid
            ? (this.state.diaDirty? css.inputDiaDirty : css.inputDia)
            : css.inputDiaInvalido
        let classnameYear = this.state.annoValid
            ? (this.state.annoDirty? css.inputAnnoDirty : css.inputAnno)
            : css.inputDiaInvalido
        return(
            <div className={"pull-right "+css.divContenedor}>
                {this.props.fechaConProblemas!=null?
                    <p className={css.diaSemanaConError}>
                        {this.props.diaSemana}
                        <span>{this.props.fechaConProblemas}</span>
                    </p>
                    :
                    <p className={css.diaSemana}>{this.props.diaSemana}</p>
                }
                <input className={classnameDia}
                       ref={ref=>this.inputDia=ref}
                       value={this.state.dia}
                       onKeyDown={this.inputOnKeyDown.bind(this)}
                       onChange={this.onDiaChange.bind(this)}
                       onBlur={()=>this.props.onGuardar()}
                       onFocus={()=>{ this.inputDia.select() }}             // seleccionar el texto cuando se hace focus
                       disabled={this.props.puedeModificar? '':'disabled'}
                />
                <input className={classnameMes} type="number"
                       ref={ref=>this.inputMes=ref}
                       value={this.state.mes}
                       onKeyDown={this.inputOnKeyDown.bind(this)}
                       onChange={this.onMesChange.bind(this)}
                       onBlur={()=>this.props.onGuardar()}
                       onFocus={()=>{ this.inputMes.select() }}             // seleccionar el texto cuando se hace focus
                       disabled={this.props.puedeModificar? '':'disabled'}
                />
                <input className={classnameYear} type="number" 
                       ref={ref=>this.inputYear=ref}
                       value={this.state.anno}
                       onKeyDown={this.inputOnKeyDown.bind(this)}
                       onChange={this.onYearChange.bind(this)}
                       onBlur={()=>this.props.onGuardar()}
                       onFocus={()=>{ this.inputYear.select() }}             // seleccionar el texto cuando se hace focus
                       disabled={this.props.puedeModificar? '':'disabled'}
                />
            </div>
        )
    }
}
InputFecha.propTypes = {
    // Objetos
    puedeModificar: React.PropTypes.bool.isRequired,
    diaSemana: React.PropTypes.string.isRequired,
    fecha: React.PropTypes.string.isRequired,
    // Metodos
    focusRowAnterior: React.PropTypes.func.isRequired,
    focusRowSiguiente: React.PropTypes.func.isRequired,
    onGuardar: React.PropTypes.func.isRequired
}
export default InputFecha


// WEBPACK FOOTER //
// ./frontEnd/components/shared/InputFecha.jsx